export default "__VITE_ASSET__Dic_waM1__"